<script lang="ts">
import { computed } from "vue";
import SummaryTableOfAuthorizationByData from "@/components/common/authorization/SummaryTableOfAuthorizationByData.vue";
import { useRouter } from "vue-router";
import LoadingAnimate from "@/components/common/LoadingAnimate.vue";
import { PropType } from "vue";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";

export default {
  name: "DetailAuthorizationModalCard",
  components: { LoadingAnimate, SummaryTableOfAuthorizationByData },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    authorization: {
      type: Object,
      required: true,
    },
    application: {
      type: Object as PropType<LocalApplicationResult>,
      required: true,
    },
    listColumnName: {
      type: Object,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
  },
  emits: ["setValidatedCharte"],
  setup(props) {
    const router = useRouter();
    let authorizationName = computed(() => {
      return props.authorization?.name || "";
    });
    let authorizationDescription = computed(() => {
      return props.authorization?.description || "";
    });
    let authorizationListAuthorizations = computed(() => {
      return props.authorization?.authorizations || [];
    });
    let authorizationId = computed(() => {
      return props.authorization?.uuid || [];
    });

    function modifyAuthorization(id: string) {
      router.push(`/applications/${props.application.name}/authorizations/${id}`);
    }
    return {
      authorizationName,
      authorizationDescription,
      authorizationListAuthorizations,
      authorizationId,
      modifyAuthorization,
    };
  },
};
</script>

<template>
  <div class="modal-card">
    <LoadingAnimate
      v-if="isLoading"
      :size="'is-large'"
    />
    <div
      v-else
      class="contentView"
    >
      <header class="modal-card-head">
        <p
          class="modal-card-title"
          :aria-label="authorizationName"
        >
          {{ authorizationName }}
        </p>
      </header>
      <div class="modal-card-body">
        <p :aria-label="authorizationDescription">
          {{ authorizationDescription }}
        </p>
        <SummaryTableOfAuthorizationByData
          :application="application"
          :authorization="authorizationListAuthorizations"
          :list-column-name="listColumnName"
          @show-more="modifyAuthorization(authorizationId)"
        />
      </div>
    </div>
  </div>
</template>
